<template>
  <div class="order-header">
    <span class="title">订单信息</span>
    <form class="search-box" onsubmit="return false;" target="rfFrame">
      <img
        class="search-img"
        @click="searchOrder"
        src="../../../../../../assets/imgs/work-wx/common/icon-search.svg"
      />
      <input
        class="search-input"
        v-model="innerValue"
        maxlength="15"
        @keydown.enter="searchOrder"
        type="search"
        placeholder="订单号、出行人"
      />
      <img
        class="delete-search"
        v-show="innerValue"
        @click="clearSearch"
        src="../../../../../../assets/imgs/work-wx/customer/btn-delete-text.svg"
      />
    </form>
    <iframe id="rfFrame" name="rfFrame" style="display: none"></iframe>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
  },
  data() {
    return {};
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    clearSearch() {
      this.innerValue = '';
      this.searchOrder();
    },
    searchOrder() {
      this.$emit('getOrderList');
    },
  },
};
</script>

<style lang="less" scoped>
.order-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 16px;
  border-bottom: 2px solid #dee3f0;
  background-color: white;
  .title {
    font-size: 14px;
    color: #2c3344;
    font-weight: bold;
  }
  .search-box {
    display: flex;
    align-items: center;
    background: #f0f2f7;
    border-radius: 14px;
    padding: 0 10px;
    width: 160px;
    height: 30px;
    .search-img {
      width: 18px;
      height: 18px;
      margin-right: 6px;
    }
    .search-input {
      width: 105px;
      outline: none;
      border: none;
      background-color: transparent;
      font-size: 14px;
      color: #2c3344;
      line-height: 20px;
      padding: 0;
      margin: 0;
      -webkit-appearance: none;
    }
    .delete-search {
      cursor: pointer;
      width: 15px;
      height: 15px;
    }
    ::-webkit-input-placeholder {
      color: #717785;
    }
    :-moz-placeholder {
      color: #717785;
    }
    ::-moz-placeholder {
      color: #717785;
    }
    :-ms-input-placeholder {
      color: #717785;
    }
  }
}
</style>
